module.exports = __webpack_public_path__ + "static/media/home-road-pickup-small_2x.224645eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-road-pickup-small_2x.png
// module id = 364
// module chunks = 27